import { useRef } from 'react'
import './Uploader.scss';
import Icon, { Icons } from '../../../Icon/Icon'
import { t } from '../../../../lang'

const Uploader = ({ onUpload }) => {
	const inputRef = useRef(null);

	const handleClick = () => {
		inputRef.current?.click();
	};

	const handleChange = e => {
		const files = Array.from(e.target.files);
		onUpload(files);

		e.target.value = '';
	};

	return (
		<>
			<input ref={inputRef} type='file' multiple className='Uploader__input' onChange={handleChange} />
			<div className='Uploader' onClick={handleClick}>
				<Icon type={Icons.PAPER_CLIP} width={32} height={32} />
				<div className='Uploader__text-content'>
					<p className='Uploader__title'>{t('Upload files')}</p>
					<p className='Uploader__subtitle'>{t('Attach supporting files for this payment')}</p>
				</div>
			</div>
		</>
	);
};

export default Uploader;